import { DataLayerAction } from '../TagContext.d'
import { useCart } from '@corratech/pylot-cart-manager'
import { useObjectCompare } from '../hooks/useObjectCompare'
import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { Cart } from '@pylot-data/pylotschema'
import { identifyCartOperationName } from './identifyCartOperationName'
import { identifyCartProductsCategories } from './identifyCartProductsCategories'
import { identifyUpdatedItems } from './identifyUpdatedItems'
import stringify from 'fast-json-stable-stringify'

export const TrackCartState = ({
    dataLayerAction
}: {
    dataLayerAction: DataLayerAction
}): null => {
    const {
        isFallback,
        query: { url_path }
    } = useRouter()
    const trackedCartState = useRef<Cart | undefined>()
    const { data } = useCart({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const cart = data?.data?.cart
    const isOptimistic = data?.data?.isOptimistic
    const hasChanges = useObjectCompare({}, ['items', 'prices'])
    useEffect(() => {
        if (cart && !isFallback && !isOptimistic && hasChanges(cart, true)) {
            const updatedItems = identifyUpdatedItems(
                cart,
                trackedCartState.current
            )

            dataLayerAction({
                type: identifyCartOperationName(cart, trackedCartState.current),
                data: {
                    ...cart,
                    updatedItems: identifyCartProductsCategories(
                        updatedItems,
                        url_path
                    )
                }
            })
            // Saved cart state needs to be stripped of internal references to the current state
            trackedCartState.current = JSON.parse(
                // @ts-ignore - options are supported but not declared in the definition
                stringify(cart, { cycles: true })
            )
        }
    }, [cart, isFallback, isOptimistic])

    return null
}
